<div class="contentHeight">
  <h1 class="text-center containerTitle" [translate]="'activlist.listebalance'"></h1>
  <div class="adminContent ">
    <!-- row mx-auto -->
    <!-- Tableau principal -->
    <div class="col-lg-8 col-md-12 mx-auto">
      <div class="table-wrapper-scroll-y my-custom-scrollbar noOverflow">
        <mat-table class="table bg-white respTab table-hover" matSort [dataSource]="activationLst" (matSortChange)="sortScale($event,'1')">
          <!-- Statut de l'activation -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'activlist.statut'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">
              <div *ngIf="res.activationStatus == 1" matTooltip="{{'activlist.statut1'|translate}}">
                <i class="fad fa-clipboard-user fa-3x twoToneRed" aria-hidden="true"></i>
              </div>
              <div *ngIf="res.activationStatus == 2" matTooltip="{{'activlist.statut2'|translate}}">
                <i class="fad fa-clipboard-user fa-3x twoToneOrange" aria-hidden="true"></i>
              </div>
              <div *ngIf="res.activationStatus == 3" matTooltip="{{'activlist.statut3'|translate}}">
                <i class="fad fa-clipboard-user fa-3x twoToneLightBlue" aria-hidden="true"></i>
              </div>
              <div *ngIf="res.activationStatus == 4 twoToneLightBlue" matTooltip="{{'activlist.statut4'|translate}}">
                <i class="fad fa-clipboard-user fa-3x twoToneBlue" aria-hidden="true"></i>
              </div>
              <div *ngIf="res.activationStatus == 5" matTooltip="{{'activlist.statut5'|translate}}">
                <i class="fad fa-clipboard-user fa-3x twoToneGreen" aria-hidden="true"></i>
              </div>
              <div *ngIf="res.activationStatus == 42" matTooltip="??">
                <i class="fad fa-clipboard-user fa-3x" aria-hidden="true"></i>
              </div>
            </mat-cell>
          </ng-container>
          <!-- Code de la balance -->
          <ng-container matColumnDef="codebalance">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'scaleform.codebalance'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.scaleCode }}</mat-cell>
          </ng-container>
          <!-- Raison sociale de la compagnie utilisateur -->
          <ng-container matColumnDef="compagnieutilisateur">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'activlist.compagnieutilisateur'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.companySocialReason }}</mat-cell>
          </ng-container>
          <!-- Date de la création de l'activation -->
          <ng-container matColumnDef="activdate">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'activlist.activdate'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.activationDate | date:'dd/MM/yyyy'}}</mat-cell>
          </ng-container>
          <!-- Code d'activation de la balance -->
          <ng-container matColumnDef="activcode">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'activlist.activcode'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.activationCode }}</mat-cell>
          </ng-container>
          <!-- Date début de licence -->
          <ng-container matColumnDef="activdatestart">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'activlist.activdatestart'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.licenceStart | date:'dd/MM/yyyy'}}</mat-cell>
          </ng-container>
          <!-- Date fin de licence -->
          <ng-container matColumnDef="activdateend">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'activlist.activdateend'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.licenceEnd | date:'dd/MM/yyyy'}}</mat-cell>
          </ng-container>
          <!-- Icone pour ouvrir la modale donnant + d'informations -->
          <ng-container matColumnDef="info">
            <mat-header-cell *matHeaderCellDef><span [translate]="'activlist.info'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">
              <i class="far fa-search-plus fa-2x pointer" (click)="displayInfoActivation(res.activationID)" aria-hidden="true"></i>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>
<!-- Modal d'information -->
<div id="modalInfo" class="modal">
  <div class="modal-content" >
    <span class="text-right close pointer" (click)="closeModal();">  <i  class="fal fa-times fa-1x5 primaryRed" aria-hidden="true"></i> </span>
    <div>
      <div *ngFor="let info of dataInfo"  class="row mx-auto ">
        <div class="col-lg-6 col-sm-12">
          <hr>
          <h3>  
            <i class="fad fa-hand-receiving twoToneBlue" aria-hidden="true"></i> 
            <span  [translate]="'scaleform.utilisateur'"></span>
          </h3>
          <div class="row">
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.nom'" ></span> : {{ info.username }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.prenom'"></span> : {{ info.userfirstname }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.telephone'"></span> : {{ info.userphone }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.mail'"></span> : {{ info.usermail }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.mobile'"></span> : {{ info.usermobile }}</div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <hr>
          <h3> 
            <i class="fad fa-industry-alt twoToneBlue" aria-hidden="true"></i> 
            <span [translate]="'activlist.compagnieutilisateur'"></span>
          </h3>
          <div class="row">
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.raisonsociale'"> </span> : {{ info.companysocialreason }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.adresse'"> </span> : {{ info.companyaddress }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.codepostal'"> </span> : {{ info.companypostalcode }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.ville'"> </span> : {{ info.companycity }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.pays'"> </span> : {{ info.companycountry }}</div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <hr>
          <h3>  
            <i class="fad fa-hand-holding-usd twoToneLightBlue" aria-hidden="true"></i> 
            <span  [translate]="'scaleform.payeur'"></span>
          </h3>
          <div class="row">
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.nom'"> </span> : {{ info.payorname }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.prenom'"> </span> : {{ info.payorfirstname }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.telephone'"> </span> : {{ info.payorphone }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.mail'"> </span> : {{ info.payormail }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.mobile'"> </span> : {{ info.payormobile }}</div>  
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <hr>
          <h3>  
              <i class="fad fa-industry-alt twoToneLightBlue" aria-hidden="true"></i> 
              <span [translate]="'activlist.compagniepayeur'"></span>
          </h3>
          <div class="row">
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.raisonsociale'"> </span> : {{ info.companyPayorsocialreason }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.adresse'"> </span> : {{ info.companyPayoraddress }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.codepostal'"></span> : {{ info.companyPayorpostalcode }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.ville'"></span> : {{ info.companyPayorcity }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.pays'"></span> : {{ info.companyPayorcountry }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.siret'"></span> : {{ info.companyPayorsiret }}</div>
            <div class="col-6"> <span class="font-weight-bold" [translate]="'scaleform.tva'"></span> : {{ info.companyPayortva }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
